import { motion } from "framer-motion";
import { Reveal, Overline } from "@/components/Reveal";
import { waLink } from "@/lib/api";
import { Sparkles } from "lucide-react";

const A = "https://customer-assets-jai6qajn.emergentagent.net/job_elixz-occasions/artifacts";

const gallery = [
  {
    img: `${A}/t5gbroou_WhatsApp%20Image%202026-07-25%20at%205.41.19%20PM%20%281%29.jpeg`,
    label: "Personalised Photo Gift Box",
    span: "md:row-span-2",
  },
  {
    img: `${A}/p00rkt0p_WhatsApp%20Image%202026-07-25%20at%205.45.53%20PM.jpeg`,
    label: "Ocean Theme Party Favours",
    span: "",
  },
  {
    img: `${A}/3yfif6qb_WhatsApp%20Image%202026-07-25%20at%205.44.54%20PM.jpeg`,
    label: "K-Pop Theme Return Favours",
    span: "",
  },
  {
    img: `${A}/73uj0w25_WhatsApp%20Image%202026-07-25%20at%205.45.27%20PM.jpeg`,
    label: "Vintage Floral Return Gifts",
    span: "md:col-span-2",
  },
  {
    img: `${A}/xyls78mu_WhatsApp%20Image%202026-07-25%20at%205.45.39%20PM.jpeg`,
    label: "Bespoke Thank-You Favours",
    span: "",
  },
];

export default function Custom() {
  return (
    <section
      id="custom"
      className="mx-auto max-w-[1400px] px-6 py-24 md:px-12 md:py-32"
      data-testid="custom"
    >
      <div className="grid gap-6 md:grid-cols-2 md:items-end">
        <div>
          <Reveal>
            <Overline>Made Just For You</Overline>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-5 max-w-2xl font-serif text-4xl font-light leading-tight md:text-6xl">
              Every order,{" "}
              <span className="gold-gradient-text italic">personalised</span> to
              your theme.
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.2}>
          <p className="max-w-md text-sm leading-relaxed text-[#A894C2] md:text-base">
            At Elixz, we craft fully customised orders around your idea — from
            ocean-theme party return gifts and K-Pop inspired favours to
            personalised photo boxes and bespoke branding. Tell us your theme,
            and we&apos;ll bring it to life.
          </p>
        </Reveal>
      </div>

      <div className="mt-14 grid auto-rows-[240px] grid-cols-1 gap-5 sm:grid-cols-2 md:grid-cols-3">
        {gallery.map((g, i) => (
          <motion.div
            key={g.label}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: (i % 3) * 0.1, ease: [0.16, 1, 0.3, 1] }}
            className={`group relative overflow-hidden rounded-2xl border border-[#311B4D] ${g.span}`}
            data-testid={`custom-card-${i}`}
          >
            <img
              src={g.img}
              alt={g.label}
              className="absolute inset-0 h-full w-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0F0616] via-[#0F0616]/20 to-transparent" />
            <div className="absolute inset-0 border border-transparent transition-colors duration-500 group-hover:border-[#D4AF37]/60" />
            <div className="relative flex h-full flex-col justify-end p-6">
              <span className="font-serif text-lg text-[#FDFBF7] md:text-xl">
                {g.label}
              </span>
            </div>
          </motion.div>
        ))}

        <Reveal className="flex flex-col items-start justify-center rounded-2xl border border-[#D4AF37]/30 bg-[#140823] p-7">
          <Sparkles size={22} className="text-gold" />
          <p className="mt-4 font-serif text-xl leading-snug text-[#FDFBF7]">
            Have a theme in mind?
          </p>
          <p className="mt-2 text-sm text-[#A894C2]">
            We&apos;ll design it around your idea.
          </p>
          <a
            href={waLink("Hi Elixz! I'd like a personalised / custom-theme order.")}
            target="_blank"
            rel="noreferrer"
            data-testid="custom-whatsapp"
            className="mt-5 rounded-full bg-gold px-6 py-3 text-sm font-semibold text-[#0F0616] transition-transform duration-300 hover:scale-[1.04] active:scale-95"
          >
            Request Custom Order
          </a>
        </Reveal>
      </div>
    </section>
  );
}
